import { Component, forwardRef, Input, OnDestroy } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { filter, Subscription, take } from 'rxjs';
import { IOption } from '../../controls/models/option';
import { AuthService } from '../../../shared/services/auth.service';
import { ProjectService } from '../shared/services/project.service';

@Component({
    selector: 'app-select-project-phase',
    templateUrl: './select-project-phase.component.html',
    styleUrl: './select-project-phase.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SelectProjectPhaseComponent),
            multi: true
        }
    ],
    standalone: false
})
export class SelectProjectPhaseComponent implements ControlValueAccessor, OnDestroy {

  @Input('value') _value: string | undefined;  
  @Input() id: string = 'select-project-phase';
  @Input() label: string = 'Phase';

  onChange: any = () => { };
  onTouched: any = () => { };

  get value() {
    return this._value;
  }

  set value(val) {
    this._value = val;
    this.onChange(val);
    this.onTouched();
  }

  loading: boolean = true;
  subscriptions: Subscription = new Subscription();
  options: IOption<string>[] = [];

  constructor(
    private _authService: AuthService,
    private _projectService: ProjectService,
  ) {
    const userSubscription = this._authService.currentUserSubject
    .pipe(
      filter(user => !!user),
      take(1)
    )    
    .subscribe(user => {
      if (user) {
        this.getProjectPhases();
      }
    });

    this.subscriptions.add(userSubscription);
  }

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  getProjectPhases() {
    const getPhases = this._projectService.getPhases().subscribe(response => {
      if (response.success) {
        const options = response.content.map(x => ({ value: x.description, label: x.description }));
        this.options = [
          { value: '', label: 'All' },
          ...options
        ];
      }

      this.loading = false;
    });

    this.subscriptions.add(getPhases);
  }
}